// extracted by mini-css-extract-plugin
export default {"component":"page_component__QEKyF","main":"page_main__yXvqJ","loadingOverlay":"page_loadingOverlay__kHJ43","btn":"page_btn__K8n-j"};